// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TokensIcons_wrapper__2COrf","icon1":"TokensIcons_icon1__3wzCF","icon2":"TokensIcons_icon2__2-MB8"};